/* src/app/workshop/components/docs/documents/documents.component.scss */
/*# sourceMappingURL=documents.component.css.map */
